import { Flex, Box, Text } from '@chakra-ui/react'
import { RewardDeprecated } from '../templates/transformLootboxRewards'
import Image from 'next/image'
import { Image as ChakraImage } from '@/components/HOC/Image'
import { getRewardShadowColor } from '@/helpers/getRewardShadowColor'
import Glow from '@/public/assets/images/lootbox/reward-bg.png'
import { motion } from 'framer-motion'
import NbzLogo from '@/public/assets/images/nbz.png'
import HydroLogo from '@/public/assets/images/hydro.webp'
import { useLootboxContext } from '@/context/LootboxProvider'
import { INJ_DENOM } from '@/constants/constants'

export const LootboxRewardDeprecated = ({
  amount,
  quantity,
  unlimited,
  chance,
  title,
  titleDenom,
  image,
  contract,
  imageSize = 72,
  showChances = true,
  glow = false,
  blured = false,
  rarity,
}: RewardDeprecated & {
  contract: string
  amount?: number
  showChances?: boolean
  imageSize?: number
  glow?: boolean
  blured?: boolean
}) => {
  const { getLootboxImagePrefix } = useLootboxContext()

  if (title === 'mystery-box') {
    // TODO: Remove
    return <MysteryReward contract={contract} />
  }

  return (
    <Box
      boxShadow={`0px 8px 40px 0px ${getRewardShadowColor(rarity)} inset;`}
      p={4}
      py={chance && showChances ? 4 : 6}
      opacity={amount === 0 ? 0.5 : 1}
      rounded={'2xl'}
      border={'1px solid'}
      borderColor={'whiteAlpha.100'}
      overflow={'hidden'}
    >
      <Box pos={'relative'} filter={blured ? 'blur(18px)' : 'none'} zIndex={10}>
        <Flex justifyContent={'end'}>
          <Box textAlign={'center'} w={20}>
            {/* <StepBadge content={`+50 NBZ`} color={StepBadgeColor.GREEN} /> */}
          </Box>
        </Flex>

        {!unlimited && quantity ? (
          <Text fontSize={'12px'} mb={4} fontWeight={700}>
            <Text color={'whiteAlpha.400'} mr={1} as={'span'}>
              Remain
            </Text>{' '}
            {amount}/{quantity}
          </Text>
        ) : null}
        <Flex pos={'relative'} justifyContent={'center'} mb={1}>
          <Box pos={'relative'} zIndex={10}>
            <Image width={imageSize} height={imageSize} src={getLootboxImagePrefix(contract) + image} alt="" />
          </Box>
          {glow && (
            <Box w={400} left={'50%'} top={'50%'} transform={'translate(-50%, -50%) '} pos={'absolute'}>
              <motion.div animate={{ rotate: 360 }} transition={{ repeat: Infinity, duration: 20, ease: 'linear' }}>
                <ChakraImage src={Glow} alt="" />
              </motion.div>
            </Box>
          )}
        </Flex>

        <Flex pos={'relative'} zIndex={10} justifyContent={'center'}>
          {titleDenom ? (
            <AmountCustomDenom value={title} denom={titleDenom} />
          ) : (
            <AmountCustomDenom value={title} denom={'HYDRO'} />
          )}
        </Flex>
        {showChances ? (
          <Flex
            mt={4}
            fontSize={'sm'}
            justifyContent={'space-between'}
            bg={'#FFFFFF04'}
            border={'1px solid'}
            borderColor={'whiteAlpha.100'}
            fontWeight={700}
            py={2}
            px={2.5}
            rounded={'xl'}
          >
            <Text color={'whiteAlpha.600'}>Chance</Text>
            <Text color={getChanceColor(chance)}>{chance}%</Text>
          </Flex>
        ) : null}
      </Box>
    </Box>
  )
}

export const MysteryReward = ({ contract, short }: { contract: string; short?: boolean }) => {
  const { getLootboxImagePrefix } = useLootboxContext()

  return (
    <Flex
      boxShadow={`0px 0px 92px -17px rgba(230, 176, 255, 0.80) inset, 0px -12px 106px -24px #4904B9 inset;`}
      px={6}
      py={4}
      rounded={'2xl'}
      border={'1px solid'}
      borderColor={'whiteAlpha.100'}
      overflow={'hidden'}
      alignItems={'center'}
      justifyContent={'end'}
      flexDir={'column'}
    >
      <Image width={90} height={90} src={getLootboxImagePrefix(contract) + 'mystery-box.png'} alt="" />
      <Text fontWeight={700} fontSize={'sm'} mt={short ? 4 : 1} mb={short ? 2 : 1} textAlign={'center'}>
        50 NBZ
      </Text>
      {!short && (
        <Text mb={2} fontWeight={500} fontSize={'x-small'} color={'brand.yellow'} textAlign={'center'}>
          Guaranteed for every box
        </Text>
      )}
    </Flex>
  )
}

export const AmountCustomDenom = ({ value, denom }: { value: string; denom: string }) => {
  return (
    <Flex alignItems={'center'} gap={1.5}>
      {denom == 'NBZ' && <ChakraImage w={'18px'} mb={'px'} src={NbzLogo} alt={''} />}
      {denom == 'HYDRO' && <ChakraImage w={'18px'} mb={'px'} src={HydroLogo} alt={''} />}
      <Text whiteSpace={'nowrap'} as={'span'} color={'white'} fontWeight={700} fontSize={'sm'}>
        {value}{' '}
        <Text color={'ninja.300'} as="span">
          {denom}
        </Text>
      </Text>
    </Flex>
  )
}

const getChanceColor = (chance: number) => {
  if (chance < 1) {
    return '#FF2A5D'
  }

  if (chance < 5) {
    return '#FF7B02'
  }

  if (chance < 15) {
    return '#FF9A02'
  }

  if (chance < 30) {
    return '#F0E04F'
  }

  return '#6ACA52'
}
